<template>
  <div class="TableRowAction">
    <div v-if="!showContent" class="handle d-flex align-items-center" @click="showContent = true">
      <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
      </svg>
      <span>
        {{ message }}
      </span>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showContent: false
    }
  },
  props: {
    message: String,
  },
  methods: {
    findPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }

      if (!found) this.showContent = false
    },
    open() {
      this.showContent = true
    },
    close() {
      this.showContent = true
    },
  },
  watch: {
    showContent(val) {
      if (val) {
        window.addEventListener("click", this.findPath, {passive: true})
        this.$emit("open")
      } else {
        window.removeEventListener("click", this.findPath)
        this.$emit("close")
      }
    },
  },
}

</script>

<style scoped>

.TableRowAction .handle {
  padding: 8px;
  font-weight: 600;
  color: var(--primary);
  cursor: pointer;
  transition-duration: .15s;
}

.TableRowAction .handle:hover {
  background-color: #f7f7f7;
}

.TableRowAction .handle span {
  transform: translateY(2px);
}

</style>

